import { render, staticRenderFns } from "./NonContributoryMember.vue?vue&type=template&id=4d9a7e6c&scoped=true"
import script from "./NonContributoryMember.vue?vue&type=script&lang=js"
export * from "./NonContributoryMember.vue?vue&type=script&lang=js"
import style0 from "./NonContributoryMember.vue?vue&type=style&index=0&id=4d9a7e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9a7e6c",
  null
  
)

export default component.exports